import patch from "../../../patch";
import Slot, {SLOT_PAYMENT_STATUS_BOOKED} from "../../../../entities/Slot";

export const book = (slot: Slot, text: string | null = null) =>
    patch<{ payment_url: string | null }>(
      `slots/${slot.id}`,
      { state: SLOT_PAYMENT_STATUS_BOOKED, text: text }
    );